import type { WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Web Item Keyword worksheet's own rules, on top of its columns'
 * character limits. Append new entries; keep one ticket's entries together
 * under its comment.
 */
export const ITEM_KEYWORD_SHEET_RULES: WorksheetRules = {
  rules: [],
  autoFills: [],
  addDefaults: [],
};
